import dayjs from "dayjs";
import { getFormattedDate } from "./components/getFormattedDate";
import {
  NEW_PARK_VISIT_TIME_INIT,
  OUTLET_TYPES,
  pieChartColors,
} from "./config/Constants";
import { BerthTariffDataType } from "./pages/BerthTariff";
import { CategoryDataType } from "./pages/CreateCategory";
import * as yup from "yup";

export const getParentPath = (path: any) => {
  let pathObj = {
    "add-merchant": "merchant",
    "edit-merchant": "merchant",
    merchant: "merchant",
    dashboard: "dashboard",
    customer: "customer",
    settings: "settings",
    report: "report",
    "push-notification": "push-notification",
    promotion: "promotion",
    "create-promo": "promotion",
    "edit-promo": "promotion",
    "topup-transactions": "topup-transactions",
    "physical-card": "physical-card",
    dispute: "dispute",
    events: "events",
    "create-event": "events",
    "edit-event": "events",
    "manage-outlet": "manage-outlet",
    "add-outlet": "manage-outlet",
    "edit-outlet": "manage-outlet",
    "amd-membership": "amd-membership",
    "register-membership": "amd-membership",
    "create-product": "manage-parks",
    "edit-product": "manage-parks",
    // "lusail-winter-wonderland": "manage-parks",
    "yacht-club": "yacht-club",
    "berth-tariff": "yacht-club",
    "parking-layout": "yacht-club",
    "manage-parks": "manage-parks",
    "special-day-pricing": "manage-parks",
    "add-park": "manage-parks",
    "edit-park": "manage-parks",
    "view-details": "yacht-club",
    "view-adddetails": "yacht-club",
    layout: "yacht-club",
    aqua: "aqua",
    "privilege-account": "privilege-account",
    "add-privilege-account": "privilege-account",
    "edit-privilege-account": "privilege-account",
    "lww-ticket": "lww-ticket",
  };
  //@ts-ignore
  return pathObj[path];
};

export const getFormattedMerchantListResponse = (data: any) => {
  let formattedData = data.map((item: any) => {
    let merchantObject = {
      id: "",
      merchant_name: "",
      merchant_id: "",
      onboard_date: "",
      status: false,
    };
    merchantObject.id = item?._id;
    merchantObject.merchant_name = item?.name;
    merchantObject.merchant_id = item?._id;
    merchantObject.onboard_date = getFormattedDate(
      item?.createdAt,
      "DD-MM-YYYY",
    );
    merchantObject.status = item?.status;
    return merchantObject;
  });
  return formattedData;
};

export const getFormatedMerchantResponse = (data: any) => {
  let merchantObj = {
    name: data?.name,
    outlet: data?.outlet,
    password: "***********", // ADDING * AS DUMMY PASSWORD SINCE PASSWORD IS NOT BEING SENT WITH MERCHANT DETAILS API
    role: data?.role,
    email: data?.email,
    status: data?.status === true ? "1" : "0",
  };

  return merchantObj;
};
export const getFormattedNotificationData = (data: any) => {
  let formattedData = data.map((item: any) => {
    let homeNotificationType =
      item?.notificationType === "home" ? "Home" : "None";
    let listNotificationObj = {
      id: "",
      title: "",
      body: "",
      date: "",
      notificationType: "",
    };
    listNotificationObj.id = item?._id;
    listNotificationObj.title = item?.title;
    listNotificationObj.body = item?.body;
    listNotificationObj.date = getFormattedDate(item?.date, "DD.MM.YYYY HH:mm");
    listNotificationObj.notificationType =
      item?.notificationType === "events" ? "Events" : homeNotificationType;
    return listNotificationObj;
  });
  return formattedData;
};

export const getFormattedRoles = (data: any) => {
  let formattedRoles = data.map((role: { key: number; value: string }) => {
    let roleObj: { value: string | number; label: string } = {
      value: "",
      label: "",
    };
    roleObj.value = role.key;
    roleObj.label = capitalizeFirstLetter(role.value.replace("_", " "));
    return roleObj;
  });
  return formattedRoles;
};

export const getFormattedOutlets = (data: any, labelName: string) => {
  let formattedOutlets = data.map(
    (outlet: { _id: string; name: string; type: string }) => {
      let outletObj: { value: string | number; label: string; type: string } = {
        value: "",
        label: "",
        type: "",
      };
      outletObj.value = outlet._id;
      outletObj.label = outlet.name;
      outletObj.type = outlet.type;
      return outletObj;
    },
  );
  formattedOutlets.unshift({
    value: "",
    label: labelName,
  });
  return formattedOutlets;
};

export const getFormattedRefundList = (data: any) => {
  let formattedList = data.map((refund: any) => {
    let refundObj: {
      outlet: string;
      customer: string;
      date_time: string;
      amount: number;
      contact: string;
      reason: string;
      comment: string;
      status: string;
      id: string;
    } = {
      outlet: "",
      id: "",
      customer: "",
      date_time: "",
      amount: 0,
      contact: "",
      reason: "",
      comment: "",
      status: "",
    };

    refundObj.outlet = refund?.outlets?.name;
    refundObj.id = refund?._id;
    refundObj.customer = refund?.user?.name;
    refundObj.date_time = getFormattedDate(refund?.dateOf, "DD/MM/YYYY HH:mm");
    refundObj.amount = refund?.amount;
    refundObj.contact = refund?.contact;
    refundObj.reason = refund?.disputeReason;
    refundObj.comment = refund?.reqComment;
    refundObj.status = capitalizeFirstLetter(refund?.status.replace("_", " "));
    return refundObj;
  });
  return formattedList;
};

function capitalizeFirstLetter(string: string) {
  return string[0].toUpperCase() + string.slice(1);
}
export const getFormattedCustomerTransactionData = (data: any) => {
  let formattedData = data.map((item: any) => {
    let customerObj = {
      name: "",
      id: "",
      date: "",
      amount: "",
    };
    customerObj.id = item?.user.userCode;
    customerObj.name = item?.user.name;
    customerObj.date = getFormattedDate(item?.createdAt, "DD.MM.YYYY HH:mm");
    customerObj.amount =
      item?.type === 0 && item?.trans_amt !== 0
        ? "-" + item?.trans_amt
        : item?.trans_amt;
    return customerObj;
  });
  return formattedData;
};

export const getFormattedReportData = (data: any) => {
  let formattedData = data.map((item: any) => {
    let merchantObject = {
      merchant_name: "",
      merchant_id: "",
      onboard_date: "",
    };
    merchantObject.merchant_name = item?.name;
    merchantObject.merchant_id = item?._id;
    merchantObject.onboard_date = getFormattedDate(
      item?.createdAt,
      "DD-MM-YYYY",
    );
    return merchantObject;
  });
  return formattedData;
};

export const getFormattedMerchantReportData = (data: any) => {
  let formattedData = data.map((item: any, index: number) => {
    let merchantReportObject = {
      id: index + 1,
      t_id: "",
      customerId: "",
      transactionDateandTime: "",
      transactionAmount: "",
      amount_qar: "",
      amount_points: "",
      disableRefundBtn: true,
    };
    merchantReportObject.customerId = item?.user.userCode;
    merchantReportObject.transactionDateandTime = getFormattedDate(
      item?.createdAt,
      "DD.MM.YYYY HH:mm",
    );
    merchantReportObject.transactionAmount = item?.trans_amt;
    merchantReportObject.amount_points = item?.points;
    merchantReportObject.amount_qar = item?.amount;
    merchantReportObject.t_id = item?._id;
    merchantReportObject.disableRefundBtn = item?.disableRefundBtn;
    return merchantReportObject;
  });
  return formattedData;
};

export const getFormattedTopUpsTransaction = (data: any) => {
  let formattedData = data.map((item: any) => {
    let topUpsTransactionObject = {
      cardId: "",
      transactionAmount: "",
      transactionDateandTime: "",
      merchantID: "",
      merchantName: "",
    };

    topUpsTransactionObject.cardId = item?.card?.cardno;
    topUpsTransactionObject.transactionAmount = item?.trans_amt + " QAR";
    topUpsTransactionObject.transactionDateandTime = getFormattedDate(
      item?.createdAt,
      "DD.MM.YYYY HH:mm:ss",
    );
    topUpsTransactionObject.merchantID = item?.merchant?._id;
    topUpsTransactionObject.merchantName = item?.merchant?.name;
    return topUpsTransactionObject;
  });
  return formattedData;
};

export const getFormattedCardList = (data: any) => {
  let formattedData = data.map((item: any, index: number) => {
    let cardListObj = {
      id: item._id,
      date_time: getFormattedDate(item?.createdAt, "DD.MM.YYYY HH:mm"),
      status: item.status,
    };
    return cardListObj;
  });
  return formattedData;
};

export const getFormatedEventResponse = (data: any) => {
  let eventObj = {
    title: data?.title,
    description: data?.description,
    location: data?.location,
    // time: data?.time && data?.time === "00:00" ? "" : data?.time,
    whatsapp: data?.whatsapp,
    phone: data?.phone,
    imageUrl: data?.imageUrl,
    date: data?.date,
    endDate: data?.endDate,
    // endTime: data?.endTime && data?.endTime === "00:00" ? "" : data?.endTime,
    isInactive: data?.isInactive === true ? "0" : "1",
    deepLinkType: data?.deepLinkType,
    deepLinkId: data?.deepLinkId,
  };
  return eventObj;
};

export const getParkTimingDetails = (data: any) => {
  let times = Object.values(data?.visitingHours);
  let isAllEqual = allEqual(times);
  let timeObj = {
    mon: {
      start: "",
      end: "",
    },
    tue: {
      start: "",
      end: "",
    },
    wed: {
      start: "",
      end: "",
    },
    thu: {
      start: "",
      end: "",
    },
    fri: {
      start: "",
      end: "",
    },
    sat: {
      start: "",
      end: "",
    },
    sun: {
      start: "",
      end: "",
    },
  };

  if (!isAllEqual) {
    Object.keys(timeObj).map((key) => {
      // @ts-ignore
      timeObj[key].start = convertTo24HourFormat(
        data?.visitingHours[key]
          ? data?.visitingHours[key].split("-")[0]?.trim()
          : "12:00 AM",
      );
      // @ts-ignore
      timeObj[key].end = convertTo24HourFormat(
        data?.visitingHours[key]
          ? data?.visitingHours[key].split("-")[1]?.trim()
          : "12:00 AM",
      );
    });
  }
  return {
    type: isAllEqual ? "single" : "multi",
    timeMulti: { ...timeObj },
    timeSingle: {
      start: isAllEqual
        ? convertTo24HourFormat(
            data?.visitingHours?.mon
              ? data?.visitingHours?.mon.split("-")[0]?.trim()
              : "12:00 AM",
          )
        : "",
      end: isAllEqual
        ? convertTo24HourFormat(
            data?.visitingHours?.mon
              ? data?.visitingHours?.mon.split("-")[1]?.trim()
              : "12:00 AM",
          )
        : "",
    },
  };
};

export const getFomattedOutletData = (dataObj: any) => {
  return {
    startDate: dataObj.startDate,
    endDate: dataObj.endDate,
    outletName: dataObj.name,
    outletType: getOutletType(dataObj.type),
    email: dataObj.email ? dataObj.email : "",
    countryCode: dataObj.countryCode
      ? dataObj.countryCode.replace("+", "")
      : "",
    phoneNumber: dataObj.phone ? dataObj.phone : "",
    outletInfo: dataObj.description,
    whatsappNumber: dataObj.shareLink[4].url,
    instaLink: dataObj.shareLink[0].url,
    fbLink: dataObj.shareLink[1].url,
    lat: dataObj.location.lat,
    long: dataObj.location.long,
    address: dataObj.address,
    shortName: dataObj.shortName ? dataObj.shortName : "",
    tripAdvisor: dataObj.shareLink[2].url,
    sevenRoomCountryCode: dataObj.reservationNumber
      ? dataObj.reservationNumber.split(" ")[0].replace("+", "")
      : "",
    sevenRoomWhatsapp: dataObj.whatsAppNumber ? dataObj.whatsAppNumber : "",
    sevenRoomContact: dataObj.reservationNumber
      ? dataObj.reservationNumber.split(" ")[1]
      : "",
    maxGuest: dataObj.maxGuestLimit ? dataObj.maxGuestLimit : "",
    venueId: dataObj.venueId ? dataObj.venueId : "",
    logoUrl: getImagesList(dataObj.logo, dataObj.name, "logo"),
    imageUrl: getImagesList(dataObj.images),
    bannerImageUrl: dataObj.bannerImage
      ? getImagesList(dataObj.bannerImage, dataObj.name, "banner")
      : [],
    iFrameUrl: dataObj.iframe_url ? dataObj.iframe_url : "",
    specialProductsDates: dataObj?.specialProductsDates || [],
    holidayAllowedDates: dataObj?.holidayAllowedDates || [],
    restrictedDates: dataObj?.restrictedDates || [],
    isLoyaltyEnabled: dataObj?.isLoyaltyEnabled,
    loyaltyTypes: dataObj?.loyaltyTypes,
    posConfigUrl: dataObj?.posConfig?.url,
    posConfigtenderMediaLoyalty: dataObj?.posConfig?.tenderMediaLoyalty,
    posConfigempId: dataObj?.posConfig?.empId,
    posConfigrevCenter: dataObj?.posConfig?.revCenter,
    notificationEmail: dataObj?.posConfig?.notificationEmail,
    surveyLink: dataObj?.surveyLink,
    receiptMerchantName: dataObj?.receiptMerchantName,
    tags: [...dataObj?.tags],
    costCenter: dataObj?.costCenter,
    companyCode: dataObj?.companyCode,
    ppLink: dataObj?.ppLink,
    tcLink: dataObj?.tcLink,
    order: dataObj?.order,

    taxType: dataObj?.taxConfig?.taxType,
    trn: dataObj?.taxConfig?.trn,
    tin: dataObj?.taxConfig?.tin,
    groupTrn: dataObj?.taxConfig?.groupTrn,
    crNumber: dataObj?.taxConfig?.crNumber,

    taxStartDate: dataObj?.taxStartDate,
    isInclusiveVAT: dataObj?.isInclusiveVAT,
    isTaxEnabled: dataObj?.isTaxEnabled,
  };
};

export const getFomattedParkData = (dataObj: any) => {
  return {
    name: dataObj.name,
    disclaimer: dataObj?.disclaimer,
    type: "parks",
    email: dataObj.email ? dataObj.email : "",
    countryCode: dataObj.countryCode
      ? dataObj.countryCode.replace("+", "")
      : "",
    phoneNumber: dataObj.phone ? dataObj.phone : "",
    info: dataObj.description,
    whatsappNumber: dataObj.shareLink[4].url,
    instaLink: dataObj.shareLink[0].url,
    fbLink: dataObj.shareLink[1].url,
    lat: dataObj.location.lat,
    long: dataObj.location.long,
    address: dataObj.address,
    shortName: dataObj.shortName ? dataObj.shortName : "",
    iframe_url: dataObj.iframe_url,
    tc: dataObj.tc,
    tripAdvisor: dataObj.shareLink[2].url,
    sevenRoomCountryCode: dataObj.reservationNumber
      ? dataObj.reservationNumber.split(" ")[0].replace("+", "")
      : "",
    sevenRoomWhatsapp: dataObj.whatsAppNumber ? dataObj.whatsAppNumber : "",
    sevenRoomContact: dataObj.reservationNumber
      ? dataObj.reservationNumber.split(" ")[1]
      : "",
    maxGuest: dataObj.maxGuestLimit ? dataObj.maxGuestLimit : "",
    venueId: dataObj.venueId ? dataObj.venueId : "",
    logoUrl: getImagesList(dataObj.logo, dataObj.name, "logo"),
    mapImage: getImagesList(dataObj.mapImage, dataObj.name, "mapImage"),
    imageUrl: getImagesList(dataObj.images),
    bannerImageUrl: dataObj.bannerImage
      ? getImagesList(dataObj.bannerImage, dataObj.name, "banner")
      : [],
    // iframe_url: dataObj.iframe_url ? dataObj.iframe_url : "",
    masterName: dataObj.master?.name,
    masterEmail: dataObj.master?.data,
    bankName: dataObj?.payment?.name,
    accountNumber: dataObj?.payment?.data,
    legalEntity: dataObj.legal?.name,
    sapCode: dataObj?.legal?.data,
    segrateTimeSlot: dataObj?.segrateTimeSlot,
    specialProductsDates: dataObj?.specialProductsDates,
    holidayAllowedDates: dataObj?.holidayAllowedDates,
    restrictedDates: dataObj?.restrictedDates,
  };
};

function getOutletType(outletType: string): string {
  let filtererdArray = OUTLET_TYPES.filter((eachType) => {
    return eachType.key === outletType;
  });
  return filtererdArray[0].value;
}

const getImagesList = (
  data: any,
  outletName?: string,
  imageType?: "logo" | "banner" | "mapImage",
) => {
  if (outletName) {
    return [
      {
        originalname: outletName + " " + (imageType || ""),
        viewUrl: data,
      },
    ];
  } else {
    let formattedData = data.map((item: any) => {
      return {
        originalname: item.title,
        viewUrl: item.url,
      };
    });
    return formattedData;
  }
};

export const getAddOutletData = (
  data: any,
  status: boolean,
  reservationStatus: boolean,
  isSevenRoomBooking: boolean,
  isIFrameBooking: boolean,
) => {
  let sumbitObject = {
    specialProductsDates: data.specialProductsDates,
    holidayAllowedDates: (data?.holidayAllowedDates || [])?.map((item: any) =>
      item.replaceAll("/", "-"),
    ),
    restrictedDates: (data?.restrictedDates || [])?.map((item: any) =>
      item.replaceAll("/", "-"),
    ),
    startDate: data.startDate,
    endDate: data.endDate,
    name: data.outletName,
    isActive: status,
    description: data.outletInfo,
    email: data.email,
    countryCode: data.phoneNumber
      ? data.countryCode === ""
        ? "+974"
        : "+" + data.countryCode
      : "",
    phone: data.phoneNumber,
    type: OUTLET_TYPES[Number(data.outletType)].key,
    logo: data.logoUrl[0].viewUrl,
    images: postImagesList(data.imageUrl),
    location: {
      lat: data.lat,
      long: data.long,
    },
    address: data.address,
    shortName: data.shortName,
    shareLink: [
      {
        type: "Instagram",
        url: data.instaLink,
      },
      {
        type: "Facebook",
        url: data.fbLink,
      },
      {
        type: "Tripadvisor",
        url: data.tripAdvisor,
      },
      {
        type: "Google Map",
        url: "",
      },
      {
        type: "Whatsapp",
        url: data.whatsappNumber,
      },
    ],
    bannerImage:
      data.bannerImageUrl.length > 0 ? data.bannerImageUrl[0].viewUrl : "",
    disableReservation: !reservationStatus,
    isSevenRoomBooking: isSevenRoomBooking,
    maxGuestLimit: data.maxGuest,
    venueId: data.venueId,
    whatsAppNumber: data.sevenRoomWhatsapp,
    reservationNumber: data.sevenRoomContact
      ? data.sevenRoomCountryCode === ""
        ? "+974 " + data.sevenRoomContact
        : "+" + data.sevenRoomCountryCode + " " + data.sevenRoomContact
      : "",
    isWebBooking: isIFrameBooking,
    iframe_url: data.iFrameUrl,
    surveyLink: data?.surveyLink,
    receiptMerchantName: data?.receiptMerchantName,
    tags: data?.tags,
    posConfig: {
      url: data.posConfigUrl,
      tenderMediaLoyalty: Number(data.posConfigtenderMediaLoyalty),
      empId: data.posConfigempId,
      revCenter: Number(data.posConfigrevCenter),
      notificationEmail: data.notificationEmail,
    },
    loyaltyTypes: data.loyaltyTypes,
    isLoyaltyEnabled: data.isLoyaltyEnabled,
    costCenter: data?.costCenter,
    companyCode: data?.companyCode,
    order: data?.order,
    tcLink: data?.tcLink,
    ppLink: data?.ppLink,
    // taxConfig: {
    //   taxType: data?.taxType,
    //   trn: data?.trn,
    //   tin: data?.tin,
    //   groupTrn: data?.groupTrn,
    //   crNumber: data?.crNumber,
    // },
    // taxStartDate: data?.taxStartDate,
    // isInclusiveVAT: data?.isInclusiveVAT,
    // isTaxEnabled: data?.isTaxEnabled,
  };
  if (data.outletType !== "2") delete sumbitObject.bannerImage;
  if (!isSevenRoomBooking) {
    delete sumbitObject.maxGuestLimit;
    delete sumbitObject.venueId;
  } else {
    delete sumbitObject.whatsAppNumber;
    //@ts-ignore
    delete sumbitObject.reservationNumber;
  }
  return sumbitObject;
};

const extractSelectedProducts = (products: any[]) => {
  if (!Array.isArray(products)) return [];

  const hasAllSelected = products.some((p) => p.value === "all" && p.selected);

  if (hasAllSelected) {
    return products.filter((p) => p.value !== "all").map((p) => p.value);
  }

  return products.filter((p) => p.selected).map((p) => p.value);
};

const getDynamicPromoData = (data: any, type: string) => {
  const baseData = {
    isEnabled: data.isEnabled === "true" ? true : false,
    startDate: data.startDate || "",
    endDate: data.endDate || "",
  };

  switch (type) {
    case "dynamicProductDiscount":
      return {
        ...baseData,
        products: Array.isArray(data.products)
          ? extractSelectedProducts(data.products)
          : [],
        discountPercentage: Number(data.discountPercentage) || 0,
        promoCode: data.promoCode || "",
        restrictedDate: Array.isArray(data.restrictedDate)
          ? data.restrictedDate
              .map((item: string) => item.replace(/\//g, "-"))
              .filter(isTodayOrFuture)
              .map((item: string) => formatToYMD(new Date(item)))
          : [],
      };

    case "dynamicProductPriceDiscount":
      return {
        ...baseData,
        products: Array.isArray(data.products)
          ? extractSelectedProducts(data.products)
          : [],
        discountedPrice: Number(data.discountedPrice) || 0,
        promoCode: data.promoCode || "",
        restrictedDate: Array.isArray(data.restrictedDate)
          ? data.restrictedDate
              .map((item: string) => item.replace(/\//g, "-"))
              .filter(isTodayOrFuture)
              .map((item: string) => formatToYMD(new Date(item)))
          : [],
      };

    case "specialDiscount":
      return {
        ...baseData,
        discountPercentage: Number(data.discountPercentage) || 0,
        promoCode: data.promoCode || "",
      };

    case "dynamicPromotion":
      return {
        ...baseData,
        products: Array.isArray(data.products)
          ? extractSelectedProducts(data.products)
          : [],
        restrictedDate: Array.isArray(data.restrictedDate)
          ? data.restrictedDate
              .map((item: string) => item.replace(/\//g, "-"))
              .filter(isTodayOrFuture)
              .map((item: string) => formatToYMD(new Date(item)))
          : [],
        details: Array.isArray(data.details)
          ? data.details.map((d: any) => ({
              minQty: Number(d.minQty) || 0,
              freeQty: Number(d.freeQty) || 0,
            }))
          : [{ minQty: 0, freeQty: 0 }],
      };

    default:
      return {};
  }
};

function formatToYMD(date: Date): string {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function isTodayOrFuture(dateStr: string): boolean {
  const inputDate = new Date(dateStr.replace(/\//g, "-"));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);
  return inputDate >= today;
}

export const getAddParkData = (
  data: any,
  status: boolean,
  time: any,
  dynamicPromoData?: any,
  dynamicPromoType?: any,
  restrictProductDiscount: any[] = [],
  id?: any,
) => {
  let sumbitObject = {
    segrateTimeSlot: data?.segrateTimeSlot,
    name: data.name,
    isActive: status,
    description: data.info,
    email: data.email,
    countryCode: data.phoneNumber
      ? data.countryCode === ""
        ? "+974"
        : "+" + data.countryCode
      : "",
    phone: data.phoneNumber,
    type: "parks",
    logo: data.logoUrl[0].viewUrl,
    images: postImagesList(data.imageUrl),
    location: {
      lat: data.lat,
      long: data.long,
    },
    address: data.address,
    shortName: data?.shortName || data.name.replace(/\s+/g, "").toLowerCase(),
    shareLink: [
      {
        type: "Instagram",
        url: data.instaLink,
      },
      {
        type: "Facebook",
        url: data.fbLink,
      },
      {
        type: "Tripadvisor",
        url: data.tripAdvisor,
      },
      {
        type: "Google Map",
        url: "",
      },
      {
        type: "Whatsapp",
        url: data.whatsappNumber,
      },
    ],
    masterName: data?.masterName,
    masterEmail: data?.masterEmail,
    bankName: data?.bankName,
    accountNumber: data?.accountNumber,
    legalEntity: data?.legalEntity,
    sapCode: data?.sapCode,
    visitingHours: getVisitingTime(time),
    disclaimer: data?.disclaimer,
    iframe_url: data?.iframe_url,
    tc: data?.tc,
    holidayAllowedDates: (data?.holidayAllowedDates || [])
      .map((item: string) => item.replace(/\//g, "-"))
      .filter(isTodayOrFuture)
      .map((item: string) => formatToYMD(new Date(item))),
    restrictedDates: (data?.restrictedDates || [])
      .map((item: string) => item.replace(/\//g, "-"))
      .filter(isTodayOrFuture)
      .map((item: string) => formatToYMD(new Date(item))),
    specialProductsDates: (data?.specialProductsDates || [])
      .map((item: string) => item.replace(/\//g, "-"))
      .filter(isTodayOrFuture)
      .map((item: string) => formatToYMD(new Date(item))),
  };
  if (id && restrictProductDiscount?.length > 0) {
    // @ts-ignore
    sumbitObject["restrictProductDiscount"] = restrictProductDiscount
      .map((item: any) => {
        const filteredDates = (
          Array.isArray(item.excludeDate) ? item.excludeDate : []
        )
          .map((date: string) => date.replace(/\//g, "-"))
          .filter(isTodayOrFuture)
          .map((dateStr: string) => formatToYMD(new Date(dateStr)));

        return {
          ...item,
          excludeDate: filteredDates,
        };
      })
      .filter(
        (item: any) =>
          item.product !== "" &&
          Array.isArray(item.excludeDate) &&
          item.excludeDate.length > 0,
      );
  } else {
    // @ts-ignore
    sumbitObject["restrictProductDiscount"] = [];
  }
  if (id && dynamicPromoType) {
    return {
      ...sumbitObject,
      [dynamicPromoType]: getDynamicPromoData(
        dynamicPromoData,
        dynamicPromoType,
      ),
    };
  } else {
    return sumbitObject;
  }
};

const getVisitingTime = (time: any) => {
  let timeObj = { ...NEW_PARK_VISIT_TIME_INIT };
  Object.keys(timeObj).map((key) => {
    // @ts-ignore
    timeObj[key] = `${
      time.type === "single"
        ? tConvert(time.timeSingle.start)
        : tConvert(time.timeMulti[key].start) ===
            tConvert(time.timeMulti[key].end)
          ? ""
          : tConvert(time.timeMulti[key].start)
    } - ${
      time.type === "single"
        ? tConvert(time.timeSingle.end)
        : tConvert(time.timeMulti[key].start) ===
            tConvert(time.timeMulti[key].end)
          ? ""
          : tConvert(time.timeMulti[key].end)
    }`;
  });

  Object.keys(timeObj).map((key) => {
    // @ts-ignore
    timeObj[key] = timeObj[key] === " - " ? "" : timeObj[key];
  });

  return timeObj;
};

export const getPromotionTime = (time: any, selectedDateWeekArray: string[]) => {
  let weeks = { mon: "", tue: "", wed: "", thu: "", fri: "", sat: "", sun: "" };
  let timeObj = { ...NEW_PARK_VISIT_TIME_INIT };
  Object.keys(timeObj).map((key) => {
    // @ts-ignore
    timeObj[key] = `${
      time.type === "single"
        ? tConvert(time.timeSingle.start)
        : tConvert(time.timeMulti[key].start) ===
            tConvert(time.timeMulti[key].end)
          ? ""
          : tConvert(time.timeMulti[key].start)
    } - ${
      time.type === "single"
        ? tConvert(time.timeSingle.end)
        : tConvert(time.timeMulti[key].start) ===
            tConvert(time.timeMulti[key].end)
          ? ""
          : tConvert(time.timeMulti[key].end)
    }`;
  });

  Object.keys(timeObj).map((key) => {
    // @ts-ignore
    timeObj[key] = timeObj[key] === " - " ? "" : timeObj[key];
  });

  const filtered = Object.keys(timeObj)
    .filter((key) => selectedDateWeekArray.includes(key))
    .reduce((obj, key) => {
      // @ts-ignore
      obj[key] = timeObj[key];
      return obj;
    }, {});

  return { ...weeks, ...filtered };
};

const postImagesList = (data: any) => {
  let formattedData = data.map((item: any) => {
    return {
      title: item.originalname,
      url: item.viewUrl,
      alt: item.originalname.substring(0, item.originalname.lastIndexOf(".")),
    };
  });
  return formattedData;
};

export const getAllOutletsData = (data: any) => {
  let formattedData = data.map((item: any) => {
    let eachOutlet = {
      _id: item._id,
      name: item.name,
      type: item.type,
      isActive: item.isActive,
      order: item.order,
    };
    return eachOutlet;
  });
  return formattedData;
};

const getHighlightStatus = (data: any) => {
  let date = dayjs(data?.endDate, "DD/MM/YYYY");
  let isoDate = date.format("YYYY-MM-DD");
  const expiryDate = new Date(isoDate);
  const currentDate = new Date();
  let val = expiryDate < currentDate ? "show" : "";
  return val;
};

export const getFormattedMembershipList = (data: any) => {
  let formattedList = data.map((membership: any) => {
    let membershipObj: any = {
      id: "",
      name: "",
      plate: "",
      istimara_photo: "",
      contact: "",
      car_type: "",
      car_brand: "",
      car_model: "",
      car_photo: "",
      year: "",
      colour: "",
      fees: "",
      start_date: "",
      expiry_date: "",
      status: "",
      isActive: false,
    };
    membershipObj.id = membership?._id;
    membershipObj.name = membership?.name;
    membershipObj.plate = membership?.carPlateNo;
    membershipObj.istimara_photo = membership?.istimaraPhoto;
    membershipObj.contact = membership?.phone;
    membershipObj.car_type = membership?.carType;
    membershipObj.car_brand = membership?.carBrand;
    membershipObj.car_model = membership?.carModel;
    membershipObj.paymentStatus = membership?.paymentStatus;
    membershipObj.car_photo = membership?.carPhoto;
    membershipObj.year = membership?.carMake;
    membershipObj.colour = membership?.carColor;
    membershipObj.fees = membership?.price;
    membershipObj.isActive = membership?.isActive;
    membershipObj.start_date = getFormattedDate(
      membership?.startDate,
      "DD/MM/YYYY",
    );
    membershipObj.expiry_date = getFormattedDate(
      membership?.endDate,
      "DD/MM/YYYY",
    );
    membershipObj.status = membership?.status;
    membershipObj.highlight = getHighlightStatus(membership);
    return membershipObj;
  });
  return formattedList;
};

export const getFormattedTransaction = (data: any) => {
  let formattedTransaction = data.map(
    (trans: { key: string; value: string }) => {
      let transObj: { value: string; label: string } = {
        value: "",
        label: "",
      };
      transObj.value = trans.key;
      transObj.label = trans.value;
      return transObj;
    },
  );
  return formattedTransaction;
};

export const getFomattedCategoryDataFromId = (data: any) => {
  return {
    categoryName: data?.name,
    status: data.isActive === true ? "1" : "0",
    categoryInformation: data?.description,
    cardColorCode: data?.bgColor,
    productId: data?.productId,
    dependentProduct: data?.dependentProduct,
    isDependent: data?.isDependent,
    aquaAvailableUnit: data?.aquaAvailableUnit,
    aquaGroup: data?.aquaGroup,
    imageUrl: getImagesList(data.imageUrl, data.name, "logo"),
    taxClassification: data?.taxClassification,
    isTaxEnabled: data?.isTaxEnabled || false,
  };
};

export const getFomattedPostCategoryData = (
  data: CategoryDataType,
  price: {
    mon: string;
    tue: string;
    wed: string;
    thu: string;
    fri: string;
    sat: string;
    sun: string;
  },
  product: any,
  pricingData: {
    type: string;
    price: string;
  },
  durations: any,
  isSpecialProduct: boolean,
) => {
  if (product === "aqua_zone") {
    return {
      isSpecialProduct: isSpecialProduct,
      name: data.categoryName,
      category: product,
      description: data.categoryInformation,
      imageUrl: data?.imageUrl[0].viewUrl,
      isDependent: data.isDependent,
      // isTaxEnabled: data.isTaxEnabled,
      // taxClassification: data.isTaxEnabled ? data.taxClassification : "",
      isActive: data.status === "1" ? true : false,
      productId: data.productId,
      aquaAvailableUnit: data.aquaAvailableUnit,
      aquaGroup: data.aquaGroup,
      aquaPrice: durations
        .filter((duration: any) => duration.value && duration.price)
        .map((duration: any) => {
          return { duration: duration.value, price: duration.price };
        }),
      aquaDuration: durations
        .filter((duration: any) => duration.value && duration.price)
        .map((duration: any) => {
          return duration.value;
        }),
    };
  } else {
    return {
      isSpecialProduct: isSpecialProduct,
      name: data.categoryName,
      category: product === "winter" ? "lww_tickets" : product,
      description: data.categoryInformation,
      isDependent: data.isDependent,
      dependentProduct: data.isDependent ? data.dependentProduct : "",
      // isTaxEnabled: data.isTaxEnabled,
      // taxClassification: data.isTaxEnabled ? data.taxClassification : "",
      isActive: data.status === "1" ? true : false,
      productId: data.productId,
      price: {
        mon:
          pricingData.type === "multi"
            ? Number(price.mon)
            : Number(pricingData.price),
        tue:
          pricingData.type === "multi"
            ? Number(price.tue)
            : Number(pricingData.price),
        wed:
          pricingData.type === "multi"
            ? Number(price.wed)
            : Number(pricingData.price),
        thu:
          pricingData.type === "multi"
            ? Number(price.thu)
            : Number(pricingData.price),
        fri:
          pricingData.type === "multi"
            ? Number(price.fri)
            : Number(pricingData.price),
        sat:
          pricingData.type === "multi"
            ? Number(price.sat)
            : Number(pricingData.price),
        sun:
          pricingData.type === "multi"
            ? Number(price.sun)
            : Number(pricingData.price),
      },
    };
  }
};

export const getFormattedProductListForDropdown = (
  data: any,
  shortName: string,
  val: string = "_id",
) => {
  if (shortName === "aqua_zone") {
    let formattedAquaData = data.map((item: any) => {
      let aquaObj = {
        label: "",
        value: false,
        selected: false,
      };
      aquaObj.value = item?.[val];
      aquaObj.label = item?.name;
      return { ...aquaObj };
    });

    return formattedAquaData;
  } else {
    let formattedData = data.map((item: any) => {
      let parkObj = {
        label: "",
        value: false,
        selected: false,
      };
      parkObj.value = item?.[val];
      parkObj.label = item?.name;
      return parkObj;
    });
    return formattedData;
  }
};

export const getFormattedProductList = (data: any, shortName: string) => {
  if (shortName === "aqua_zone") {
    let formattedAquaData = data.map((item: any) => {
      let aquaObj = {
        _id: "",
        isActive: false,
        name: "",
        inventory: "",
        category: "",
        subtitle: "",
        productId: "",
      };
      aquaObj._id = item?._id;
      aquaObj.isActive = item?.isActive;
      aquaObj.name = item?.name;
      aquaObj.subtitle = item?.description;
      aquaObj.category = item?.aquaGroup;
      aquaObj.inventory = item?.aquaAvailableUnit;
      aquaObj.productId = item?.productId || "-";
      const result = {};
      item?.aquaPrice?.length > 0 &&
        item?.aquaPrice?.forEach((price: any) => {
          // @ts-ignore
          result[price.duration] = `${price.price} QAR`;
        });
      return { ...aquaObj, ...result };
    });

    return formattedAquaData;
  } else {
    let formattedData = data.map((item: any) => {
      let parkObj = {
        _id: "",
        isActive: false,
        name: "",
        price: {},
        bgColor: "",
        productId: "",
        description: "",
      };
      parkObj._id = item?._id;
      parkObj.isActive = item?.isActive;
      parkObj.name = item?.name;
      parkObj.description = item?.description;
      parkObj.price = item?.price;
      parkObj.bgColor = item?.bgColor ? "#" + item?.bgColor : "";
      parkObj.productId = item?.productId || "-";
      return parkObj;
    });
    return formattedData;
  }
};

export const getFormattedDiscountTypes = (data: any) => {
  let formattedData = data.map((item: any) => {
    let discountObj = {
      label: "",
      value: "",
      key: "",
    };
    discountObj.label = item?.value;
    discountObj.value = item?.key;
    discountObj.key = item?.key;
    return discountObj;
  });
  return formattedData;
};
export const getFormattedParks = (data: any) => {
  let formattedData = data.map((item: any) => {
    let parkObj = {
      label: "",
      value: "",
      hours: "",
    };
    parkObj.label = item?.name;
    parkObj.value = item?._id;
    parkObj.hours = item?.visitingHours;
    return parkObj;
  });
  return formattedData;
};

export const getFormattedProducts = (data: any) => {
  let formattedData = data.map((item: any) => {
    let parkObj = {
      label: "",
      value: "",
      code: "",
    };
    parkObj.label = item?.name;
    parkObj.value = item?._id;
    parkObj.code = item?.productId;
    return parkObj;
  });
  return formattedData;
};

export const getFormattedSelectFields = (data: any) => {
  let formattedData = data.map((item: any) => ({
    label: item?.value,
    value: item?.key,
  }));
  return formattedData;
};

export const getFormattedPieData = (data: any) => {
  let valueArray = [];
  let venueArray = [];
  let colorArray = [];

  for (let i = 0; i < data.length; i++) {
    valueArray.push(data[i].reservationCount);
    venueArray.push(data[i].name);
    colorArray.push(pieChartColors[i]);
  }
  return { valueArray, venueArray, colorArray };
};

export const getFormattedBerthListData = (data: any) => {
  let formattedData = data.map((item: any) => {
    let berthObj = {
      id: "",
      range: "",
      annual: "",
      monthly: "",
      daily: "",
      dropOrPickUp: "",
      isActive: false,
    };
    berthObj.id = item._id;
    berthObj.range = item.range;
    berthObj.annual = item.annual ? item.annual.price : "";
    berthObj.monthly = item.monthly ? item.monthly.price : "";
    berthObj.daily = item.daily ? item.daily.price : "";
    berthObj.dropOrPickUp = item.dropOrPickUp ? item.dropOrPickUp.price : "";
    berthObj.isActive = item.isActive;
    return berthObj;
  });
  return formattedData;
};

export const getFormattedYachtRegistrationData = (data: any) => {
  let formattedData = data.map((item: any) => {
    let yachtRegObj = {
      id: "",
      name: "",
      phone: "",
      createdAt: "",
      visitDate: "",
      visiTime: "",
      vesselLoa: "",
      package: "",
      additionalService: false,
    };
    yachtRegObj.id = item._id;
    yachtRegObj.name = item.name;
    yachtRegObj.phone = item.phone;
    yachtRegObj.createdAt = item.createdAt;
    yachtRegObj.visitDate = item.visitDate;
    yachtRegObj.visiTime = item.visiTime;
    yachtRegObj.vesselLoa = item.vesselLoa;
    yachtRegObj.package = item.package;
    yachtRegObj.additionalService = item.additionalService;
    return yachtRegObj;
  });
  return formattedData;
};

export const getFormattedYachtHistoryData = (data: any) => {
  let formattedData = data.map((item: any) => {
    let yachtRegObj = {
      id: "",
      name: "",
      phone: "",
      parkingSpot: "",
      package: "",
      additionalService: false,
      status: "",
      paymentStatus: "",
    };
    yachtRegObj.id = item._id;
    yachtRegObj.name = item.name;
    yachtRegObj.phone = item.phone;
    yachtRegObj.parkingSpot = item.parkingSpace;
    yachtRegObj.package = item.package;
    yachtRegObj.additionalService = item.additionalService;
    yachtRegObj.status = item.status;
    yachtRegObj.paymentStatus = item.paymentStatus;
    return yachtRegObj;
  });
  return formattedData;
};

export const getFormattedPostBerthData = (
  data: BerthTariffDataType,
  isActive: boolean,
) => {
  return {
    range: data.range,
    annual: {
      price: Number(data.annual),
    },
    monthly: {
      price: Number(data.monthly),
    },
    daily: {
      price: Number(data.daily),
    },
    dropOrPickUp: {
      price: Number(data.dropOrPickUp),
    },
    isActive: isActive,
  };
};

export const getFomattedTariffFromId = (data: any) => {
  return {
    range: data.range,
    annual: data.annual.price,
    monthly: data.monthly.price,
    daily: data.daily.price,
    dropOrPickUp: data.dropOrPickUp.price,
  };
};

export const getFormattedPaymentPayloadForApproval = (
  data: any,
  berthID: string,
) => {
  return {
    approved: 1,
    rejectNotes: "",
    paymentMode: data.paymentMode,
    berthId: berthID,
    ...(data.paymentMode !== "online" && {
      payNote:
        data.paymentMode === "cheque" ? data.chequeNumber : data.cashAmount,
    }),
  };
};

export function titleCase(str: string) {
  let words = str?.toLowerCase().split(" ");
  for (let i = 0; i < words?.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }
  return words?.join(" ");
}

export const getFormattedYachtAdditionalServiceData = (data: any) => {
  let formattedData = data.map((item: any) => {
    let yachtAddServiceObj = {
      id: "",
      name: "",
      phone: "",
      createdAt: "",
      visitDate: "",
      visiTime: "",
      vesselLoa: "",
    };
    yachtAddServiceObj.id = item._id;
    yachtAddServiceObj.name = item.user.name;
    yachtAddServiceObj.phone = item.user.phone;
    yachtAddServiceObj.createdAt = item.createdAt;
    yachtAddServiceObj.visitDate = item.date;
    yachtAddServiceObj.visiTime = item.time;
    yachtAddServiceObj.vesselLoa = item.vesselLoa;
    return yachtAddServiceObj;
  });
  return formattedData;
};

export const getFormattedYachtAdditionalServiceHistoryData = (data: any) => {
  let formattedData = data.map((item: any) => {
    let yachtAddServiceHistoryObj = {
      id: "",
      name: "",
      phone: "",
      visitDate: "",
      visiTime: "",
      vesselLoa: "",
      serviceStatus: "",
    };
    yachtAddServiceHistoryObj.id = item._id;
    yachtAddServiceHistoryObj.name = item.user.name;
    yachtAddServiceHistoryObj.phone = item.user.phone;
    yachtAddServiceHistoryObj.visitDate = item.date;
    yachtAddServiceHistoryObj.visiTime = item.time;
    yachtAddServiceHistoryObj.vesselLoa = item.vesselLoa;
    yachtAddServiceHistoryObj.serviceStatus = titleCase(item.status);
    return yachtAddServiceHistoryObj;
  });
  return formattedData;
};

export const getFormattedDuration = (data: any) => {
  let formattedData = "";
  if (data === "annual") {
    formattedData = "year";
  } else if (data === "monthly") {
    formattedData = "month";
  } else {
    formattedData = "day";
  }
  return formattedData;
};

export const getFormattedEventDateTime = (eventDate: any, eventTime: any) => {
  let formattedTime =
    eventTime && eventTime !== "00:00"
      ? eventDate + ` (${eventTime})`
      : eventDate;
  let formattedDateTime = eventDate ? formattedTime : "";
  return formattedDateTime;
};

export const getFomattedpromoData = (data: any) => {
  return {
    code: data?.code,
    title: data?.name,
    description: data?.description,
    isUnlimited: data?.isUnlimited,
    discountType: data?.discountType,
    percentage: data?.percentage,
    isPublic: data?.isPublic,
    startDate: getFormattedDate(data?.startDate, "YYYY-MM-DD"),
    endDate: getFormattedDate(data?.endDate.split("T")[0], "YYYY-MM-DD"),
    // startTime: data?.startTime,
    // endTime: data?.endTime,
    outlet: data?.outlet || "all",
    products: data?.products?.length > 0 ? [...data?.products] : [],
    imageUrl: data?.bannerImage,
    showInApp: data?.showInApp,
    isActive: data?.isActive,
    tag: data?.tag || [],
    maxUseCount: data?.maxUseCount,
    countPerUser: data?.countPerUser,
    maxQtyApplicable: data?.maxQtyApplicable,
    freeProduct: data?.freeProduct,
    isFreeProduct: data?.isFreeProduct,
  };
};

export const getFormattedPromoTime = (data: any) => {
  let timeObj = {
    mon: {
      start: "",
      end: "",
    },
    tue: {
      start: "",
      end: "",
    },
    wed: {
      start: "",
      end: "",
    },
    thu: {
      start: "",
      end: "",
    },
    fri: {
      start: "",
      end: "",
    },
    sat: {
      start: "",
      end: "",
    },
    sun: {
      start: "",
      end: "",
    },
  };

  if (data.isMultitime) {
    Object.keys(timeObj).map((key) => {
      // @ts-ignore
      timeObj[key].start = convertTo24HourFormat(
        data?.multiTimings[key]
          ? data?.multiTimings[key].split("-")[0]?.trim()
          : "12:00 AM",
      );
      // @ts-ignore
      timeObj[key].end = convertTo24HourFormat(
        data?.multiTimings[key]
          ? data?.multiTimings[key].split("-")[1]?.trim()
          : "12:00 AM",
      );
    });
  }

  let returnObj = {
    type: data?.isMultitime ? "multi" : "single",
    timeMulti: { ...timeObj },
    timeSingle: {
      start: data?.startTime ? convertTo24HourFormat(data?.startTime) : "00:00",
      end: data?.endTime ? convertTo24HourFormat(data?.endTime) : "23:59",
    },
  };
  console.log(returnObj);

  return returnObj;
};

export const getFormattedEventTime = (data: any) => {
  let timeObj = {
    mon: {
      start: "",
      end: "",
    },
    tue: {
      start: "",
      end: "",
    },
    wed: {
      start: "",
      end: "",
    },
    thu: {
      start: "",
      end: "",
    },
    fri: {
      start: "",
      end: "",
    },
    sat: {
      start: "",
      end: "",
    },
    sun: {
      start: "",
      end: "",
    },
  };

  if (data.isMultitime) {
    Object.keys(timeObj).map((key) => {
      // @ts-ignore
      timeObj[key].start = convertTo24HourFormat(
        data?.multiTimings[key]
          ? data?.multiTimings[key].split("-")[0]?.trim()
          : "12:00 AM",
      );
      // @ts-ignore
      timeObj[key].end = convertTo24HourFormat(
        data?.multiTimings[key]
          ? data?.multiTimings[key].split("-")[1]?.trim()
          : "12:00 AM",
      );
    });
  }
  let returnObj = {
    type: data?.isMultitime ? "multi" : "single",
    timeMulti: { ...timeObj },
    timeSingle: {
      start: data?.time ? convertTo24HourFormat(data?.time) : "00:00",
      end: data?.endTime ? convertTo24HourFormat(data?.endTime) : "23:59",
    },
  };
  console.log(returnObj);

  return returnObj;
};

const getformatPostTag = (data: any) => {
  let tagArray = data
    .filter((item: any) => item.selected)
    .map((item: any) => item.label);

  if (tagArray[0] === "none") {
    return [];
  } else {
    return tagArray;
  }
};

export const getAddpromoData = (data: any, time: any) => {
  let promoObj = {
    code: "",
    name: "",
    description: "",
    isUnlimited: "",
    discountType: "",
    percentage: "",
    isPublic: "",
    startDate: "",
    endDate: "",
    outlet: "",
    products: [],
    bannerImage: "",
    showInApp: "",
    isActive: "",
    tag: [],
    isMultitime: "",
    freeProduct: "",
    isFreeProduct: "",
    // multiTimings: {},
  };

  promoObj.code = data?.code;
  promoObj.name = data?.title;
  promoObj.description = data?.description;
  promoObj.isUnlimited = data?.isUnlimited;
  promoObj.discountType = data?.discountType;
  promoObj.percentage = data?.percentage !== "" ? data.percentage : 0;
  promoObj.isPublic = data?.isPublic;
  promoObj.startDate = data?.startDate;
  promoObj.endDate = data?.endDate;
  promoObj.outlet = data?.outlet === "all" ? "" : data?.outlet;
  promoObj.products = data?.products;
  promoObj.bannerImage = data?.imageUrl?.viewUrl || data?.imageUrl;
  promoObj.showInApp = data?.showInApp;
  promoObj.isActive = data?.isActive;
  promoObj.tag = data?.tag;
  promoObj.isFreeProduct = data?.isFreeProduct;
  promoObj.freeProduct = data?.freeProduct || null;
  // @ts-ignore
  promoObj.isMultitime = time?.type === "single" ? false : true;

  if (time?.type === "single") {
    // @ts-ignore
    promoObj.startTime = time.timeSingle.start;
    // @ts-ignore
    promoObj.endTime = time.timeSingle.end;
  }
  if (time?.type === "multi") {
    // @ts-ignore
    promoObj.multiTimings = getPromotionTime(
      time,
      getWeekArray(data?.startDate, data?.endDate),
    );
  }

  if (!data?.isUnlimited) {
    // @ts-ignore
    promoObj.maxUseCount = data?.maxUseCount;
    // @ts-ignore
    promoObj.countPerUser = data?.countPerUser;
  }

  if (data.discountType === "product") {
    // @ts-ignore
    promoObj.maxQtyApplicable = Number(data?.maxQtyApplicable);
  }

  return promoObj;
};

export const allEqual = (arr: any) => arr.every((val: any) => val === arr[0]);

export const tConvert = (time: any) => {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
};

export const isStartTimeGreaterThanEndTime = (startTime: any, endTime: any) => {
  // Convert the times to 24-hour format

  const startTime24 = convertTo24HourFormat(startTime);

  const endTime24 = convertTo24HourFormat(endTime);

  // Compare the times

  return startTime24 > endTime24;
};

const convertTo24HourFormat = (time12Hour: any) => {
  // Split the time into parts (hours, minutes, AM/PM)

  const parts = time12Hour.split(" ");

  const time = parts[0];

  const period = parts[1];

  // Split the time into hours and minutes

  let [hours, minutes] = time.split(":").map(Number);

  // Convert to 24-hour format

  if (period === "PM" && hours !== 12) {
    hours += 12;
  } else if (period === "AM" && hours === 12) {
    hours = 0;
  }

  // Format as HH:mm
  const hours24 = hours.toString().padStart(2, "0");

  const minutes24 = minutes.toString().padStart(2, "0");

  return `${hours24}:${minutes24}`;
};

export const getFormattedPrivilegeList = (data: any) => {
  let formattedData = data.map((item: any) => {
    let privilegeObj = {
      name: "",
      status: "",
      id: "",
      discount: "",
    };
    privilegeObj.id = item?._id;
    privilegeObj.name = item?.name;
    privilegeObj.discount = item?.percentage;
    privilegeObj.status = item?.isActive;
    return privilegeObj;
  });
  return formattedData;
};

export const validateAccountData = (data: any, setError: any) => {
  const schema = yup.object().shape({
    name: yup.string().required("Account name is required"),
    type: yup.string().required("Account type is required"),
    isActive: yup.boolean().required(),
    benefits: yup
      .array()
      .of(yup.string())
      .test(
        "at-least-one-non-empty",
        "At least one benefit is required",
        function (value: any) {
          console.log(value);

          const nonEmptyValues = value.filter(
            (benefit: any) => benefit.trim() !== "",
          );
          return nonEmptyValues.length > 0;
        },
      ),
    percentage: yup
      .number()
      .typeError("Discount must be in percentage")
      .min(0, "Please enter valid discount")
      .max(100, "Please enter valid discount")
      .required("Discount is required"),
    qrLineColor: yup.string().matches(/^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, {
      message: "Invalid hex color code",
    }),
    nameTextColor: yup.string().matches(/^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, {
      message: "Invalid hex color code",
    }),
    badgeHomeImg: yup.array().min(1, "Please upload a image"),
    badgeProfileImg: yup.array().min(1, "Please upload a image"),
    bgMenuImg: yup.array().min(1, "Please upload a image"),
    bgHomeImg: yup.array().min(1, "Please upload a image"),
    benefitsFile: yup.array().min(1, "Please upload a benefits file"),
  });

  schema
    .validate(data, { abortEarly: false })
    .then(() => {})
    .catch((validationErrors) => {
      validationErrors.inner.forEach((error: any) => {
        setError((prevState: any) => ({
          ...prevState,
          [error.path]: error.message,
        }));
      });
    });

  return schema.isValidSync(data);
};

export const getFormattedAccountData = (data: any) => {
  return {
    type: data.type,
    name: data.name,
    isActive: data.isActive,
    benefits: [...data.benefits],
    percentage: data.percentage,
    qrLineColor: data.qrLineColor,
    badgeHomeImg: getImagesList(data.badgeHomeImg, "badge-home"),
    badgeProfileImg: getImagesList(data.badgeProfileImg, "badge-profile"),
    bgMenuImg: getImagesList(data.bgMenuImg, "bg-menu"),
    bgHomeImg: getImagesList(data.bgHomeImg, "bg-home"),
    benefitsFile: data.benefitsFile
      ? getImagesList(data.benefitsFile, "benefitsFile")
      : [],
    nameTextColor: data?.nameTextColor,
  };
};

export const getFormattedPostableAccountData = (data: any) => {
  return {
    ...data,
    benefits: data.benefits.filter((benefit: string) => benefit),
    badgeHomeImg: data.badgeHomeImg[0].viewUrl,
    badgeProfileImg: data.badgeProfileImg[0].viewUrl,
    bgMenuImg: data.bgMenuImg[0].viewUrl,
    bgHomeImg: data.bgHomeImg[0].viewUrl,
    benefitsFile: data.benefitsFile[0].viewUrl,
  };
};

export const getWeekArray = (sDate: any, eDate: any) => {
  let startDate = new Date(sDate);
  let endDate = new Date(eDate);

  let weekdays = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  let result = [];

  while (startDate <= endDate && result.length < 7) {
    result.push(weekdays[startDate.getDay()]);
    startDate.setDate(startDate.getDate() + 1);
  }

  return result;
};

export const isAlphanumeric = (str: any) => {
  return /^[a-zA-Z0-9]+$/.test(str);
};

export const validateRegAMDData = (data: any, setError: any) => {
  const currentYear = new Date().getFullYear();
  const schema = yup.object().shape({
    name: yup.string().required("Name is required"),
    lastname: yup.string().required("Lastname is required"),
    email: yup
      .string()
      .email("Invalid email format")
      .required("Email is required"),
    phone: yup
      .number()
      .typeError("Phone number must be a number")
      .required("Phone number is required"),
    countryCode: yup
      .number()
      .typeError("Country code must be a number")
      .required("Country code is required"),
    carPlateNo: yup.string().required("Car plate number is required"),
    carBrand: yup.string().required("Car brand is required"),
    carModel: yup.string().required("Car model is required"),
    carType: yup.string().required("Car type is required"),
    carMake: yup
      .number()
      .min(1900, "Car make year must be valid")
      .max(
        currentYear,
        `Car make year must be at or before the current year (${currentYear})`,
      )
      .typeError("Car make must be a valid year")
      .required("Car make is required"),
    carColor: yup.string().required("Car color is required"),
    carPhoto: yup
      .string()
      .url("Car photo must be a valid URL")
      .required("Car photo is required"),
    istimaraPhoto: yup
      .string()
      .url("Istimara photo must be a valid URL")
      .required("Istimara photo is required"),
  });

  schema
    .validate(data, { abortEarly: false })
    .then(() => {})
    .catch((validationErrors) => {
      validationErrors.inner.forEach((error: any) => {
        setError((prevState: any) => ({
          ...prevState,
          [error.path]: error.message,
        }));
      });
    });

  return schema.isValidSync(data);
};
